<template>
    <div class="container pt-2">
        <PageTitle icon="fa fa-address-card" main="Pagamento de Jobs" sub="Página de exibição dos jobs para pagamento" />
        <!-- PAGAMENTO -->
        <b-modal id="modal-payment" hide-footer>
            <template v-slot:modal-title>
                Defina a Forma de Pagamento
            </template>
            <div class="d-block text-center">
            <b-form>
                <div class="row">
                    <div class="col-md-12">
                        <b-form-group label="Forma de Pagamento:" label-for="job-forma">
                            <b-form-select id="job-forma" :options="pagamentos" v-model="pagamento"/>
                        </b-form-group>
                    </div>
                </div>
                <div class="row" v-if="pagamento==='cartao'">
                    <div class="col-md-12">
                        <b-form-group label="Número:" label-for="pagamento-numero">
                            <b-form-input id="pagamento-numero" type="text"
                                v-model="payment.numero"
                                v-mask="'#### #### #### ####'"
                                placeholder="Informe o numero do cartão."/>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group label="Titular:" label-for="pagamento-titular">
                            <b-form-input id="pagamento-titular" type="text"
                                v-model="payment.titular"
                                placeholder="Informe o titular do cartão."/>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Validade:" label-for="pagamento-validade">
                            <b-form-input id="pagamento-validade" type="text"
                                v-model="payment.validade"
                                v-mask="'##/##'"
                                placeholder="Informe o validade do cartão."/>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Código de Segurança:" label-for="pagamento-cvv">
                            <b-form-input id="pagamento-cvv" type="text"
                                v-model="payment.cvv"
                                v-mask="'###'"
                                placeholder="Informe o cvv do cartão."/>
                        </b-form-group>
                    </div>
                </div>
            </b-form>
            </div>
            <b-button variant="success" class="mt-3" block @click="setPayment">Realizar Pagamento</b-button>
        </b-modal>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-jobs" 
                class="text-center table table-sm" 
                :items="jobs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(servico)="data">
                    {{ data.item.categoria_titulo }}->{{ data.item.subcategoria_titulo }}->{{ data.item.id_tiposervico_titulo }}
                </template>
                <template v-slot:cell(prazo)="data">
                    {{ data.item.id_tiposervico_prazo }} dias
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1" @click="openPayment(data.item)" 
                        v-if="data.item.status==='AGUARDANDO PAGAMENTO' && 
                        (nivel==='admin' || nivel==='ambos' || nivel==='tomador')">
                        <font-awesome-icon :icon="['fa', 'money-bill-wave']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-jobs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-jobs" 
                class="text-center table table-sm" 
                :items="jobs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(servico)="data">
                    {{ data.item.categoria_titulo }}->{{ data.item.subcategoria_titulo }}->{{ data.item.id_tiposervico_titulo }}
                </template>
                <template v-slot:cell(prazo)="data">
                    {{ data.item.id_tiposervico_prazo }} dias
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1" @click="openPayment(data.item)" 
                        v-if="data.item.status==='AGUARDANDO PAGAMENTO' && 
                        (nivel==='admin' || nivel==='ambos' || nivel==='tomador')">
                        <font-awesome-icon :icon="['fa', 'money-bill-wave']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-jobs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mask } from 'vue-the-mask'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'pagamentoJobs',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            nivel: '',
            pagamento: '',
            pagamentos: [
                { value: 'boleto', text: 'Boleto' },
                { value: 'cartao', text: 'Cartão de Crédito' }
            ],
            job: {},
            jobs: [],
            transacao: {},
            payment: {},
            quemRecebeu: '',
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            fields: [
                { key: 'numero', label: 'Número', sortable: true },
                { key: 'servico', label: 'Serviço', sortable: true },
                { key: 'dataPublicacao', label: 'Data de Publicação', sortable: true, formatter: 'formatData' },
                { key: 'prazo', label: 'Prazo', sortable: true },
                { key: 'status', label: 'Status', sortable: true },
                { key: 'actions', label: 'Ações', thStyle: { width: '20%' }  }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    computed: {
        rows() {
            return this.jobs.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        openPayment(job) {
            this.job = job
            this.$bvModal.show('modal-payment')
        },
        setPayment() {
                this.payment.job = this.job.id
                this.payment.valor = this.job.id_tiposervico_valor_receber
                this.payment.repasse = this.job.id_tiposervico_valor_pagar
                this.payment.pagador = this.quemRecebeu
                if(this.pagamento === 'cartao') {
                    this.payment.modo = 'cartao'
                } else {
                    this.payment.modo = 'boleto'
                }
                axios['post'](`${baseApiUrl}/backend/GENERAL/payment.php?job=${this.payment.job}`, this.payment)
                .then(() => {
                    this.$bvModal.hide('modal-payment')

                    this.transacao.id_colaborador = this.job.quemPublicou
                    this.transacao.id_job = this.job.id
                    this.transacao.id_servico = this.job.id_tiposervico
                    this.transacao.status = 'CREDITO_JOB_' + this.job.id
                    this.transacao.tipo = 'credito'
                    this.transacao.valor = this.job.id_tiposervico_valor_receber
                    this.transacao.liberado = 'nao'
                    axios['post'](`${baseApiUrl}/backend/INSERT/transacoes.php`, this.transacao)
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Pagamento realizado com sucesso!' })
                    })
                    .catch((e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    })
                                
                    this.reset()

                })
                .catch(
                    (e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                }
                )
        },
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        loadJobs() {
            const url = `${baseApiUrl}/backend/SELECT/pagarJobs.php?colaborador=${this.quemRecebeu}`
            axios.get(url).then(res => {
                this.jobs = res.data
                this.exibeRodape = false
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.exibeRodape = true
            })
        },
        reset() {
            this.job = {}
            this.transacao = {}
            this.loadJobs()
        },
        loadJob(job) {
            this.job = { ...job }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.nivel === 'prestador') {
            this.$router.push('/')
        }
        this.loadJobs()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.jobs.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

.text-custom {
    font-size: 0.8rem;
}
</style>